import React, { useState } from 'react';
import './style/progressBar.css';
import { FaCheck } from "react-icons/fa";


const steps = ['Patient Name', 'Vendor', 'Tests', 'Complete', 'Review'];

function ProgressBar({activeStep}) {

 

  return (
    <div className="progress-bar">
      <div className="progress-bar-steps">
        {steps.map((step, index) => (
          <div key={step} className={`step ${index <= activeStep ? 'active-progress' : ''}`}>
            <div className="step-content">
              <div className="step-number">
                {index < activeStep ? <FaCheck  
                  color='black'
                /> : index + 1}
              </div>
             
              <div className="step-title">{step}</div>
            </div>
            {index < steps.length - 1 && <div className="step-line"></div>}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProgressBar;
